import { AbsoluteFill, useCurrentFrame } from "remotion";
import { activeLines, type ScriptLine } from "./script";
import { BRAND, FONTS } from "./theme";

/**
 * Kinetic caption overlay. Renders the active VO line(s) for the current frame
 * as a lower-third. MUST be a sibling of <Stage> (it is DOM, not 3D).
 *
 * `sceneStartFrame` lets a scene pass 0 (it already lives inside its own
 * <Sequence>, so useCurrentFrame is scene-local).
 */
export const Caption: React.FC<{
  lines: ScriptLine[];
  sceneStartFrame?: number;
}> = ({ lines, sceneStartFrame = 0 }) => {
  const frame = useCurrentFrame() - sceneStartFrame;
  const active = activeLines(lines, frame);
  if (active.length === 0) return null;
  return (
    <AbsoluteFill
      style={{
        justifyContent: "flex-end",
        alignItems: "center",
        paddingBottom: 96,
        pointerEvents: "none",
      }}
    >
      <div
        style={{
          maxWidth: 1500,
          textAlign: "center",
          color: BRAND.white,
          fontFamily: FONTS.body,
          fontSize: 40,
          lineHeight: 1.3,
          textShadow: `0 2px 24px ${BRAND.space0}`,
          background: "rgba(8,14,32,0.55)",
          padding: "18px 32px",
          borderRadius: 16,
          borderBottom: `3px solid ${BRAND.cyan}`,
        }}
      >
        {active.map((l, i) => (
          <div key={i}>{l.caption}</div>
        ))}
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
